(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  class CartDrawer extends HTMLElement {
    static get drawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId || 'cart-drawer';
      this.bindLocalEvents();
      this.initSchedule();
    }

    initSchedule() {
      if (this.dataset.scheduleEnabled !== 'true') return;

      const start = () => {
        if (!window.ThemeCartSchedule) {
          window.setTimeout(start, 20);
          return;
        }

        new window.ThemeCartSchedule(this);
      };

      start();
    }

    bindLocalEvents() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-drawer-close]')) {
          this.close();
        }
      });

      this.addEventListener('click', (event) => {
        const quantityBtn = event.target.closest('[data-quantity-change]');
        if (!quantityBtn) return;

        const item = quantityBtn.closest('[data-cart-item]');
        const change = parseInt(quantityBtn.dataset.quantityChange, 10);
        const currentQty = parseInt(item.querySelector('[data-quantity-value]').textContent, 10);
        const newQty = Math.max(0, currentQty + change);

        this.updateLineItem(item.dataset.lineKey, newQty);
      });
    }

    open() {
      this.classList.add('cart-drawer--open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-open');
    }

    close() {
      this.classList.remove('cart-drawer--open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-open');
    }

    async refresh() {
      const root = window.Shopify?.routes?.root || '/';
      const wasOpen = this.classList.contains('cart-drawer--open');

      try {
        const response = await fetch(`${root}?sections=${this.sectionId}`);
        const data = await response.json();
        const html = data[this.sectionId];

        if (!html) return;

        const template = document.createElement('template');
        template.innerHTML = html.trim();
        const newDrawer = template.content.querySelector('[data-cart-drawer]');

        if (!newDrawer) return;

        this.replaceWith(newDrawer);

        if (wasOpen) {
          newDrawer.open();
        }
      } catch (error) {
        console.error(error);
      }
    }

    async updateLineItem(key, quantity) {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });

        if (!response.ok) throw new Error('Cart update failed');

        await CartDrawer.drawer?.refresh();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        console.error(error);
      }
    }

    static async addToCart(form) {
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        const formData = new FormData(form);
        const response = await fetch(`${window.Shopify?.routes?.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity') || '1', 10),
          }),
        });

        if (!response.ok) throw new Error('Add to cart failed');

        await CartDrawer.drawer?.refresh();
        CartDrawer.drawer?.open();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        console.error(error);
        form.submit();
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-open]')) {
        event.preventDefault();
        CartDrawer.drawer?.open();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && CartDrawer.drawer?.classList.contains('cart-drawer--open')) {
        CartDrawer.drawer.close();
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action.includes('/cart/add')) return;

      event.preventDefault();
      CartDrawer.addToCart(form);
    });

    document.addEventListener('cart:updated', async () => {
      try {
        const cart = await fetch(`${window.Shopify?.routes?.root}cart.js`).then((response) => response.json());

        document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
          let count = trigger.querySelector('.cart-drawer-trigger__count');

          if (cart.item_count > 0) {
            if (!count) {
              count = document.createElement('span');
              count.className = 'cart-drawer-trigger__count';
              trigger.appendChild(count);
            }
            count.textContent = cart.item_count;
          } else if (count) {
            count.remove();
          }
        });
      } catch (error) {
        console.error(error);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.bindEvents();
      this.initSchedule();
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const quantityBtn = event.target.closest('[data-quantity-change]');
        if (quantityBtn) {
          const item = quantityBtn.closest('[data-cart-item]');
          const change = parseInt(quantityBtn.dataset.quantityChange, 10);
          const currentQty = parseInt(item.querySelector('[data-quantity-value]').textContent, 10);
          const newQty = Math.max(0, currentQty + change);
          this.updateLineItem(item.dataset.lineKey, newQty);
          return;
        }

        const removeBtn = event.target.closest('[data-remove-item]');
        if (removeBtn) {
          const item = removeBtn.closest('[data-cart-item]');
          this.updateLineItem(item.dataset.lineKey, 0);
        }
      });
    }

    initSchedule() {
      if (this.dataset.scheduleEnabled !== 'true') return;

      const start = () => {
        if (!window.ThemeCartSchedule) {
          window.setTimeout(start, 20);
          return;
        }

        new window.ThemeCartSchedule(this);
      };

      start();
    }

    async updateLineItem(key, quantity) {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });

        if (!response.ok) throw new Error('Cart update failed');

        await this.refresh();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        console.error(error);
      }
    }

    async refresh() {
      if (!this.sectionId) return;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}?sections=${this.sectionId}`);
        const data = await response.json();
        const html = data[this.sectionId];

        if (!html) return;

        const template = document.createElement('template');
        template.innerHTML = html.trim();
        const newPage = template.content.querySelector('cart-page');

        if (!newPage) return;

        this.replaceWith(newPage);
      } catch (error) {
        console.error(error);
      }
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-header-menu-toggle]');
      this.menu = this.querySelector('[data-header-menu]');
      if (!this.toggle || !this.menu) return;

      this.toggle.addEventListener('click', () => {
        if (this.isOpen()) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      });

      this.menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.closeMenu());
      });

      this.handleKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen()) {
          this.closeMenu();
        }
      };

      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);
    }

    isOpen() {
      return this.classList.contains('site-header--menu-open');
    }

    openMenu() {
      this.menu.hidden = false;

      requestAnimationFrame(() => {
        this.classList.add('site-header--menu-open');
      });

      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('site-header-menu-open');
    }

    closeMenu() {
      if (!this.isOpen()) return;

      this.classList.remove('site-header--menu-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('site-header-menu-open');

      let closed = false;
      const finishClose = () => {
        if (closed) return;
        closed = true;
        this.menu.hidden = true;
      };

      const onTransitionEnd = (event) => {
        if (event.target !== this.menu || event.propertyName !== 'clip-path') return;
        this.menu.removeEventListener('transitionend', onTransitionEnd);
        finishClose();
      };

      this.menu.addEventListener('transitionend', onTransitionEnd);
      window.setTimeout(finishClose, 500);
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mooncake-hero"] && !Shopify.designMode) return;
  try {
    
  class MooncakeHero extends HTMLElement {
    connectedCallback() {
      if (this._isConnected) return;
      this._isConnected = true;

      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.dotIndex, 10);
          this.goToSlide(index);
          this.resetAutoplay();
        });
      });

      this.initSwipe();

      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this._isConnected = false;
      this.stopAutoplay();
      this.dragController?.destroy();
      this.dragController = null;
    }

    initSwipe() {
      if (typeof window.CarouselDrag !== 'function') return;

      this.dragController = new window.CarouselDrag({
        surface: this.querySelector('.mooncake-hero__slides'),
        slides: this.slides,
        wrap: true,
        getIndex: () => this.currentIndex,
        onSnapComplete: (index) => this.snapToSlide(index),
        onDragStart: () => this.stopAutoplay(),
        onDragEnd: () => this.resetAutoplay(),
        clickSuppressSelector: 'a, button',
        draggableClass: 'mooncake-hero__slides--draggable',
        draggingClass: 'mooncake-hero__slides--dragging',
      });
    }

    snapToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;

      this.dragController?.cancelAnimation();
      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('mooncake-hero__slide--active', slideIndex === index);
      });

      this.updateDots(index);
      this.currentIndex = index;
    }

    updateDots(index) {
      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('mooncake-hero__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;
      if (index < 0 || index >= this.slides.length) return;

      this.dragController?.cancelAnimation();
      this.dragController?.clearDragStyles();

      const outgoing = this.slides[this.currentIndex];
      const incoming = this.slides[index];

      incoming.style.zIndex = '2';
      incoming.classList.add('mooncake-hero__slide--active');
      outgoing.classList.remove('mooncake-hero__slide--active');

      this.updateDots(index);
      this.currentIndex = index;

      const finishTransition = (event) => {
        if (event.target !== incoming || event.propertyName !== 'opacity') return;
        incoming.removeEventListener('transitionend', finishTransition);
        outgoing.style.zIndex = '';
        incoming.style.zIndex = '';
      };

      incoming.addEventListener('transitionend', finishTransition);
      window.setTimeout(() => {
        outgoing.style.zIndex = '';
        incoming.style.zIndex = '';
      }, 700);
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    startAutoplay() {
      this.timer = window.setInterval(() => this.nextSlide(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    resetAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('mooncake-hero')) {
    customElements.define('mooncake-hero', MooncakeHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-boxes"] && !Shopify.designMode) return;
  try {
    
  class OurBoxes extends HTMLElement {
    connectedCallback() {
      if (this._isConnected) return;
      this._isConnected = true;

      this.boxes = Array.from(this.querySelectorAll('[data-box]'));
      this.navList = this.querySelector('[data-nav-list]');
      this.navGroups = Array.from(this.querySelectorAll('[data-nav-group]'));
      this.grid = this.querySelector('[data-box-grid]');
      this.background = this.querySelector('.our-boxes__background');
      this.navButtons = Array.from(this.querySelectorAll('.our-boxes__nav-item'));

      if (this.navButtons.length === 0 || this.boxes.length === 0 || !this.navList || !this.grid) return;

      this.gridParent = this.grid.parentElement;
      this.gridNextSibling = this.grid.nextElementSibling;
      this.mobileMedia = window.matchMedia('(max-width: 640px)');
      this.handleMediaChange = () => {
        this.updateBackgroundLayout();
        this.updateNavLayout();
      };
      this.handleNavClick = (event) => {
        const button = event.target.closest('.our-boxes__nav-item');
        if (!button || !this.navList.contains(button)) return;

        const isMobile = this.mobileMedia.matches;
        const isAlreadyActive = button.classList.contains('our-boxes__nav-item--active');

        if (isMobile && isAlreadyActive) {
          this.setActiveNav(null);
          return;
        }

        this.setActiveNav(button);
      };

      this.mobileMedia.addEventListener('change', this.handleMediaChange);
      this.navList.addEventListener('click', this.handleNavClick);
      this.updateNavLayout();
      this.updateBackgroundLayout();

      const activeButton = this.navButtons.find((button) => button.classList.contains('our-boxes__nav-item--active'));
      if (activeButton) {
        this.updateGridColumns(activeButton.dataset.category);
      }
    }

    disconnectedCallback() {
      this._isConnected = false;
      this.mobileMedia?.removeEventListener('change', this.handleMediaChange);
      this.navList?.removeEventListener('click', this.handleNavClick);
    }

    updateNavLayout() {
      if (this.mobileMedia.matches) {
        this.layoutMobileNav();
        return;
      }

      this.layoutDesktopNav();
    }

    layoutMobileNav() {
      let activePanel = null;

      this.navGroups.forEach((group) => {
        const button = group.querySelector('.our-boxes__nav-item');
        const panel = group.querySelector('[data-nav-panel]');
        const isActive = button.classList.contains('our-boxes__nav-item--active');

        group.classList.toggle('our-boxes__nav-group--active', isActive);
        button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        panel.hidden = !isActive;

        if (isActive) {
          activePanel = panel;
        }
      });

      this.moveGridToParent();

      if (activePanel) {
        activePanel.appendChild(this.grid);
        this.showGrid();
      } else {
        this.hideGrid();
      }
    }

    moveGridToParent() {
      if (this.gridNextSibling) {
        this.gridParent.insertBefore(this.grid, this.gridNextSibling);
      } else {
        this.gridParent.appendChild(this.grid);
      }
    }

    showGrid() {
      this.grid.hidden = false;
      this.grid.removeAttribute('hidden');
      this.grid.classList.remove('our-boxes__grid--collapsed');
    }

    hideGrid() {
      this.grid.hidden = true;
      this.grid.setAttribute('hidden', '');
      this.grid.classList.add('our-boxes__grid--collapsed');
    }

    layoutDesktopNav() {
      this.navGroups.forEach((group) => {
        const button = group.querySelector('.our-boxes__nav-item');
        const panel = group.querySelector('[data-nav-panel]');

        group.classList.remove('our-boxes__nav-group--active');
        panel.hidden = true;
        button.setAttribute('aria-expanded', 'false');
      });

      this.moveGridToParent();
      this.showGrid();
    }

    filterByCategory(category) {
      this.boxes.forEach((box) => {
        if (box.dataset.category === category) {
          box.classList.remove('our-boxes__card--hidden');
        } else {
          box.classList.add('our-boxes__card--hidden');
        }
      });

      this.updateGridColumns(category);
    }

    updateBackgroundLayout() {
      if (!this.background || this.boxes.length === 0) return;

      this.grid.style.minHeight = '';
      const maxHeight = this.measureMaxSectionHeight();
      this.style.setProperty('--our-boxes-bg-height', `${maxHeight}px`);
    }

    captureNavState() {
      const activeButton = this.navButtons.find((button) =>
        button.classList.contains('our-boxes__nav-item--active')
      );

      return {
        category: activeButton?.dataset.category ?? null,
      };
    }

    restoreNavState(category) {
      if (category) {
        const activeButton = this.navButtons.find((button) => button.dataset.category === category);
        this.setActiveNav(activeButton ?? null);
        return;
      }

      this.setActiveNav(null);
    }

    applyMeasurementState(category) {
      this.boxes.forEach((box) => {
        box.classList.toggle('our-boxes__card--hidden', box.dataset.category !== category);
      });
      this.updateGridColumns(category);

      this.navButtons.forEach((button) => {
        const isActive = button.dataset.category === category;
        button.classList.toggle('our-boxes__nav-item--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      this.navGroups.forEach((group) => {
        const button = group.querySelector('.our-boxes__nav-item');
        const panel = group.querySelector('[data-nav-panel]');
        const isActive = button.dataset.category === category;

        group.classList.toggle('our-boxes__nav-group--active', isActive);
        panel.hidden = !isActive;
      });

      if (this.mobileMedia.matches) {
        this.layoutMobileNav();
      } else {
        this.layoutDesktopNav();
      }
    }

    measureMaxSectionHeight() {
      const categories = [...new Set(this.boxes.map((box) => box.dataset.category))];
      const savedState = this.captureNavState();
      let maxHeight = 0;

      categories.forEach((category) => {
        this.applyMeasurementState(category);
        maxHeight = Math.max(maxHeight, this.offsetHeight);
      });

      this.restoreNavState(savedState.category);
      return maxHeight;
    }

    updateGridColumns(category) {
      if (!this.grid || !category) return;

      const activeButton = this.navButtons.find((button) => button.dataset.category === category);
      const count = parseInt(activeButton?.dataset.categoryCount || '0', 10);

      this.grid.classList.toggle('our-boxes__grid--two-products', count === 2);
    }

    setActiveNav(activeButton) {
      this.navButtons.forEach((button) => {
        const isActive = activeButton !== null && button === activeButton;
        button.classList.toggle('our-boxes__nav-item--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      this.navGroups.forEach((group) => {
        const button = group.querySelector('.our-boxes__nav-item');
        const panel = group.querySelector('[data-nav-panel]');
        const isActive = activeButton !== null && button === activeButton;

        group.classList.toggle('our-boxes__nav-group--active', isActive);
        panel.hidden = !isActive;
      });

      if (activeButton) {
        this.filterByCategory(activeButton.dataset.category);
      }

      this.updateNavLayout();
    }
  }

  if (!customElements.get('our-boxes')) {
    customElements.define('our-boxes', OurBoxes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-delivery"] && !Shopify.designMode) return;
  try {
    
  class ProductDelivery extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-delivery-toggle]');
      this.content = this.querySelector('[data-delivery-content]');

      if (!this.toggle || !this.content) return;

      this.toggle.addEventListener('click', () => {
        const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
        this.toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        this.content.classList.toggle('product-delivery__content--open', !isOpen);
      });
    }
  }

  if (!customElements.get('product-delivery')) {
    customElements.define('product-delivery', ProductDelivery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  class ProductDetails extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-details-toggle]');
      this.content = this.querySelector('[data-details-content]');

      if (!this.toggle || !this.content) return;

      this.toggle.addEventListener('click', () => {
        const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
        this.toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        this.content.classList.toggle('product-details__content--open', !isOpen);
      });
    }
  }

  if (!customElements.get('product-details')) {
    customElements.define('product-details', ProductDetails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  class ProductHero extends HTMLElement {
    connectedCallback() {
      if (this._isConnected) return;
      this._isConnected = true;

      this.quantityInput = this.querySelector('[data-quantity-input]');
      this.minusBtn = this.querySelector('[data-quantity-minus]');
      this.plusBtn = this.querySelector('[data-quantity-plus]');
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.addToCartBtn = this.querySelector('[data-add-to-cart]');

      if (this.minusBtn && this.quantityInput) {
        this.minusBtn.addEventListener('click', () => {
          const current = parseInt(this.quantityInput.value, 10) || 1;
          if (current > 1) {
            this.quantityInput.value = current - 1;
          }
        });
      }

      if (this.plusBtn && this.quantityInput) {
        this.plusBtn.addEventListener('click', () => {
          const current = parseInt(this.quantityInput.value, 10) || 1;
          this.quantityInput.value = current + 1;
        });
      }

      this.initVariantPicker();
      this.initCarousel();
    }

    disconnectedCallback() {
      this._isConnected = false;
      this.stopAutoplay();
      this.dragController?.destroy();
      this.dragController = null;
    }

    initVariantPicker() {
      const variantsJson = this.querySelector('[data-product-variants-json]');
      if (!variantsJson || !this.variantIdInput) return;

      this.variants = JSON.parse(variantsJson.textContent);
      this.priceEl = this.querySelector('[data-product-price]');
      this.addToCartLabel = this.addToCartBtn?.dataset.addToCartLabel || '';
      this.soldOutLabel = this.addToCartBtn?.dataset.soldOutLabel || '';

      this.optionalPicker = this.querySelector('[data-optional-upgrade-picker]');
      if (this.optionalPicker) {
        this.initOptionalUpgradePicker();
        return;
      }

      this.optionGroups = Array.from(this.querySelectorAll('[data-option-group]'));
      this.optionInputs = Array.from(this.querySelectorAll('[data-option-input]'));

      if (this.optionGroups.length === 0) return;

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          this.updateSelectedVariant();
          this.updateOptionAvailability();
        });
      });

      this.updateOptionAvailability();
      this.updateSelectedVariant();
    }

    initOptionalUpgradePicker() {
      this.defaultVariantId = Number(this.optionalPicker.dataset.defaultVariantId);
      this.upgradeCheckboxes = Array.from(this.optionalPicker.querySelectorAll('[data-optional-upgrade]'));

      if (this.upgradeCheckboxes.length === 0) return;

      this.upgradeCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          if (checkbox.checked) {
            this.upgradeCheckboxes.forEach((otherCheckbox) => {
              if (otherCheckbox !== checkbox) {
                otherCheckbox.checked = false;
              }
            });
          }

          this.applyOptionalVariant();
        });
      });

      this.applyOptionalVariant();
    }

    applyOptionalVariant() {
      const checkedCheckbox = this.upgradeCheckboxes.find((checkbox) => checkbox.checked);
      const variantId = checkedCheckbox
        ? Number(checkedCheckbox.dataset.variantId)
        : this.defaultVariantId;
      const variant = this.variants.find((item) => item.id === variantId);

      if (!variant) return;

      if (checkedCheckbox && !variant.available) {
        checkedCheckbox.checked = false;
        this.applyOptionalVariant();
        return;
      }

      this.applyVariantState(variant);
    }

    applyVariantState(variant) {
      this.variantIdInput.value = variant.id;

      if (this.priceEl) {
        const currentPriceEl = this.priceEl.querySelector('[data-product-current-price]');
        const comparePriceEl = this.priceEl.querySelector('[data-product-compare-price]');
        const formattedPrice = this.formatMoney(variant.price);

        if (currentPriceEl) {
          currentPriceEl.textContent = formattedPrice;
        }

        if (comparePriceEl) {
          if (variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = this.formatMoney(variant.compare_at_price);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }
      }

      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = !variant.available;
        this.addToCartBtn.textContent = variant.available
          ? this.addToCartBtn.dataset.addToCartLabel
          : this.addToCartBtn.dataset.soldOutLabel;
      }
    }

    getSelectedOptions() {
      return this.optionGroups.map((group) => {
        const checked = group.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    findVariantForOptions(options) {
      if (options.some((value) => value === null)) return null;

      return this.variants.find((variant) =>
        options.every((value, index) => variant[`option${index + 1}`] === value)
      );
    }

    updateOptionAvailability() {
      this.optionGroups.forEach((group) => {
        const position = Number(group.dataset.optionPosition);
        const radios = group.querySelectorAll('[data-option-input]');

        radios.forEach((radio) => {
          const testOptions = this.optionGroups.map((optionGroup) => {
            const optionPosition = Number(optionGroup.dataset.optionPosition);

            if (optionPosition === position) {
              return radio.value;
            }

            const checked = optionGroup.querySelector('[data-option-input]:checked');
            return checked ? checked.value : null;
          });

          const variant = this.findVariantForOptions(testOptions);
          const isUnavailable = !variant || !variant.available;

          radio.disabled = isUnavailable;
        });
      });
    }

    getSelectedVariant() {
      if (!this.variants || this.optionGroups.length === 0) return null;

      return this.findVariantForOptions(this.getSelectedOptions());
    }

    formatMoney(cents) {
      const currency = this.dataset.currency || 'USD';

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency,
        }).format(cents / 100);
      } catch {
        return `${currency} ${(cents / 100).toFixed(2)}`;
      }
    }

    updateSelectedVariant() {
      const variant = this.getSelectedVariant();
      if (!variant) return;

      this.applyVariantState(variant);
    }

    initCarousel() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.dotIndex, 10);
          this.goToSlide(index);
          this.resetAutoplay();
        });
      });

      this.initSwipe();

      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    initSwipe() {
      const setup = () => {
        if (typeof window.CarouselDrag !== 'function') return false;

        this.dragController?.destroy();
        this.dragController = new window.CarouselDrag({
          surface: this.querySelector('.product-hero__slides'),
          slides: this.slides,
          wrap: true,
          getIndex: () => this.currentIndex,
          onSnapComplete: (index) => this.snapToSlide(index),
          onDragStart: () => this.stopAutoplay(),
          onDragEnd: () => this.resetAutoplay(),
          draggableClass: 'product-hero__slides--draggable',
          draggingClass: 'product-hero__slides--dragging',
        });

        return true;
      };

      if (setup()) return;

      requestAnimationFrame(() => {
        if (!setup()) {
          window.addEventListener('load', () => setup(), { once: true });
        }
      });
    }

    snapToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;

      this.dragController?.cancelAnimation();
      this.dragController?.clearDragStyles();

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('product-hero__slide--active', slideIndex === index);
      });

      this.updateDots(index);
      this.currentIndex = index;
    }

    updateDots(index) {
      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('product-hero__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;
      if (index < 0 || index >= this.slides.length) return;

      this.dragController?.cancelAnimation();
      this.dragController?.clearDragStyles();

      const outgoing = this.slides[this.currentIndex];
      const incoming = this.slides[index];

      incoming.style.zIndex = '2';
      incoming.classList.add('product-hero__slide--active');
      outgoing.classList.remove('product-hero__slide--active');

      this.updateDots(index);
      this.currentIndex = index;

      const finishTransition = (event) => {
        if (event.target !== incoming || event.propertyName !== 'opacity') return;
        incoming.removeEventListener('transitionend', finishTransition);
        outgoing.style.zIndex = '';
        incoming.style.zIndex = '';
      };

      incoming.addEventListener('transitionend', finishTransition);
      window.setTimeout(() => {
        outgoing.style.zIndex = '';
        incoming.style.zIndex = '';
      }, 700);
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    startAutoplay() {
      this.timer = window.setInterval(() => this.nextSlide(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    resetAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('product-hero')) {
    customElements.define('product-hero', ProductHero);
  }

  } catch(e) { console.error(e); }
})();
})();
